import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Navigation from '@/components/Navigation/Navigation';
import ParentAppChrome from '@/components/Parent/ParentAppChrome';

/**
 * Shared chrome for Account subpages and similar parent-only screens.
 */
export default function ParentSubpageShell({
	title,
	backTo,
	backLabel = '← Back',
	intro,
	children,
	hideNav = false,
}) {
	const innerHeight = useSelector((state) => state.content.innerHeight);

	return (
		<div style={{ minHeight: innerHeight }} className='parent-ui'>
			<ParentAppChrome />
			<main className='parent-main'>
				{backTo && (
					<Link to={backTo} className='back'>
						{backLabel}
					</Link>
				)}
				{title && <h1>{title}</h1>}
				{intro && <p className='muted subpage-intro'>{intro}</p>}
				{children}
			</main>
			{!hideNav && <Navigation />}
		</div>
	);
}
